import { type SelectFieldProps, SelectField, useGetList } from "react-admin";

import { type ModuleValue } from "@/types/modules";

type Props = SelectFieldProps & {
  module: ModuleValue;
};

const STALE_TIME = 60_000;

export const ReferenceField = (props: Props) => {
  const { module, ...rest } = props;
  const {
    data = [],
    isPending,
    isLoading,
  } = useGetList(
    module,
    { sort: { field: "id", order: "ASC" } },
    {
      staleTime: STALE_TIME,
    },
  );

  return (
    <SelectField
      {...rest}
      isPending={isPending}
      isLoading={isLoading}
      choices={data}
    />
  );
};
